<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="cotacoes.content"
      class="elevation-1 mt-5"
      :loading="loading"
      :server-items-length="cotacoes.total"
      @update:options="updateOptions"
      :footer-props="footerOptions"
      no-data-text="Nenhuma cotação encontrada"
      loading-text="Carregando cotações..."
      :options="optionsList"
    >
      <template v-slot:item.identificador="{ item }">
        <px-lista-cotacao-identificador :cotacao="item"
                                        :save-function="saveIdentifier"
                                        @update="emitUpdate"/>
      </template>
      <template v-slot:item.comprador.nome="{ item }">
        <px-span-tooltip top :text="comprador(item)" :tooltip="item.comprador.pessoa.nome"/>
      </template>
      <template v-slot:item.transportadora="{ item }">
        {{item.company.pessoa.nome }}
      </template>
      <template v-slot:item.createdIn="{ item }">
        {{item.createdIn | date(true)}}
      </template>
      <template v-slot:item.quantidadeItens="{ item }">
        {{item.quantidadeItens}} itens(s)
      </template>
      <template v-slot:item.quantidadeRespostas="{ item }">
        {{item.quantidadeRespostas}} resposta(s)
      </template>
      <template v-slot:item.origem="{ item }">
        {{item.municipioColeta.nome}}
        ({{item.municipioColeta.estado.sigla}})
      </template>
      <template v-slot:item.destino="{ item }">
        {{item.municipioEntrega.nome}}
        ({{item.municipioEntrega.estado.sigla}})
      </template>
      <template v-slot:item.options="{ item }">
        <v-btn icon link :to="`cotacoes-fretes/${item.id}`">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn icon link :to="`/cadastro-cotacao-frete?copia=${item.id}`" v-on="on">
              <v-icon>mdi-content-copy</v-icon>
            </v-btn>
          </template>
          <span>Copiar cotação de frete</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Vue from 'vue';
import ListaCotacaoIdentificador from './components/ListaCotacaoIdentificador.vue';
import CotacaoFreteService from './cotacao-frete-service';

export default {
  props: {
    cotacoes: Object,
    default: [],
    loading: Boolean,
    onChangeOptions: {
      type: Function,
      required: true,
    },
    optionsList: Object,
    footerOptions: Object,
  },
  data() {
    return {
      saveIdentifier: CotacaoFreteService.updateIdentifier,
      headers: [
        {
          text: 'Identificador',
          value: 'identificador',
        },
        {
          text: 'Empresa',
          value: 'transportadora',
        },
        {
          text: 'Data de entrada',
          value: 'createdIn',
        },
        {
          text: 'Itens',
          sortable: false,
          value: 'quantidadeItens',
        },
        {
          text: 'Respostas',
          sortable: false,
          value: 'quantidadeRespostas',
        },
        {
          text: 'Origem',
          value: 'origem',
          sortable: false,
        },
        {
          text: 'Destino',
          value: 'destino',
          sortable: false,
        },
        {
          text: null,
          sortable: false,
          value: 'options',
        },
      ],
    };
  },
  computed: {
    comprador() {
      return item => Vue.filter('truncate')(item.comprador.pessoa.nome, 20);
    },
  },
  methods: {
    updateOptions(options) {
      this.onChangeOptions(options);
    },
    emitUpdate() {
      this.$emit('update');
    },
  },
  components: {
    pxListaCotacaoIdentificador: ListaCotacaoIdentificador,
  },
};
</script>
